import { createRedirectListener } from 'www/utils'

createRedirectListener({ className: 'b-card__avatar' })
